import { create } from 'zustand';

interface AuthData {
  retailerId: string;
  dszEmail: string;
}

interface AuthDataActions {}

type AuthDataStore = AuthData & AuthDataActions;

const useAuthDataStore = create<AuthDataStore>((set, get) => ({
  retailerId: localStorage.getItem('customer_id') || '',
  dszEmail: localStorage.getItem('dsz_email') || ''
}));

export default useAuthDataStore;
